export const STUB_PAGES: Record<string, { title: string; subtitle: string }> = {}

export function isStubView(view: string): view is keyof typeof STUB_PAGES {
  return view in STUB_PAGES
}
